import React
from "react";

import Header
from "../../../components/Header";

import LeftMenu
from "../../../components/LeftMenu";

import EvaLiveExpert
from "./components/EvaLiveExpert";

import "./EvaMainChat.css";


export default function EvaMainChat()
{

    return (

        <div
            className="eva-demo-page"
        >

            <EvaLiveExpert />

        </div>

    );

}